export const PAYMENT_OPTION = {
	CASH: 'CASH',
	ENCAR_LOAN: 'ENCAR_LOAN',
	ENCAR_PAY: 'ENCAR_PAY',
};

export const NOMINEE_VALUE_TYPE = {
	PERSONAL: 'PERSONAL',
	PERSONAL_BUSINESS: 'PERSONAL_BUSINESS',
	CORPORATION_BUSINESS: 'CORPORATION_BUSINESS',
};

export const REFUND_BANK_LIST = [
	{ key: 'bank0', value: '없음', name: '은행선택' },
	{ key: 'bank1', value: '산업', name: '산업' },
	{ key: 'bank2', value: '기업', name: '기업' },
	{ key: 'bank3', value: '국민', name: '국민' },
	{ key: 'bank4', value: '수협', name: '수협' },
	{ key: 'bank5', value: '농협', name: '농협' },
	{ key: 'bank6', value: '우리', name: '우리' },
	{ key: 'bank7', value: '제일', name: '제일' },
	{ key: 'bank8', value: '씨티', name: '씨티' },
	{ key: 'bank9', value: '대구', name: '대구' },
	{ key: 'bank10', value: '부산', name: '부산' },
	{ key: 'bank11', value: '광주', name: '광주' },
	{ key: 'bank12', value: '제주', name: '제주' },
	{ key: 'bank13', value: '전북', name: '전북' },
	{ key: 'bank14', value: '경남', name: '경남' },
	{ key: 'bank15', value: '새마을금고', name: '새마을금고' },
	{ key: 'bank16', value: '신협', name: '신협' },
	{ key: 'bank17', value: '우체국', name: '우체국' },
	{ key: 'bank18', value: '하나', name: '하나' },
	{ key: 'bank19', value: '신한', name: '신한' },
];

export const NOMINEE_INFO = {
	개인: {
		ownershipRate: 100,
		name: '',
		phone: '',
		email: '',
		addressInfo: null,
	},
	대표: {
		ownershipRate: 50,
		name: '',
		phone: '',
		email: '',
		addressInfo: null,
	},
	공동: {
		ownershipRate: 50,
		name: '',
		phone: '',
		addressInfo: null,
	},
	법인: {
		ownershipRate: 100,
		name: '',
		phone: '',
		addressInfo: null,
	},
};

export const ADDRESS_INFO = {
	buildingCd: '',
	postCd: '',
	address: '',
};

export const REFUND_ACCOUNT_INFO = {
	bank: '없음',
	name: '',
	number: '',
};

export const CORPORATION_INFO = {
	corporateName: '',
	businessNumber: '',
	invoiceEmail: '',
};

export const BUSINESS_INFO = {
	businessName: '',
	businessNumber: '',
	invoiceEmail: '',
	addressInfo: ADDRESS_INFO,
};

export const CUSTOMER_INFO = {
	name: '',
	phone: '',
	userId: '',
};

export const WARRANTY_VALUE = {
	TWELVE: 12,
	NINE: 9,
	SIX: 6,
	NONE: 0,
};

// 수입차 보증 상품 코드 (첫 항목 기준으로 수입차 판정)
export const IMPORTED_WARRANTY_CODES = ['EE1', 'EE2', 'EE3', 'EE4'];

// 기본 보증 개월수 정책용 상품 코드 (buy 홈서비스 EstimateContainer.initWarranty 와 동일)
export const DOMESTIC_LARGE_WARRANTY_CODES = ['E03', 'E04']; // 국산 대형/특대형 → 12개월
export const IMPORTED_LARGE_WARRANTY_CODES = ['EE3', 'EE4']; // 수입 대형·스포츠카/특대형 → 9개월

export default null;
